<template>
  <div class="auth-container">
    <!-- Left Panel - Illustration -->
    <div class="auth-left-panel">
      <div class="auth-content">
        <div
          class="auth-logo d-flex flex-column align-items-center justify-content-center"
        >
          <img src="../../assets/img/Logo.png" alt="Logo" class="logo-img" />
          <img
            src="../../assets/img/Slogan.png"
            alt="Slogan"
            class="logo-img"
          />
          <img
            src="../../assets/img/Contact.png"
            alt="Contact"
            class="logo-img mt-2"
          />
        </div>
      </div>
    </div>

    <!-- Right Panel - Reset Password Form -->
    <div class="auth-right-panel">
      <div class="auth-form-container">
        <!-- Header -->
        <!-- Reset Password Form -->
        <div class="auth-form">
          <v-form @submit.prevent="handleForgotPassword" ref="resetForm">
            <div class="form-group">
              <v-text-field
                style="margin-top: -12px"
                v-model="email"
                type="email"
                :placeholder="$t('text.enter-your-email')"
                :rules="emailRules"
                variant="outlined"
                density="compact"
                hide-details="auto"
                @input="clearErrorMessage"
              ></v-text-field>
            </div>
            <div class="error-message" v-if="errorMessage">
              <v-icon left color="error" class="error-icon"
                >mdi-alert-circle</v-icon
              >
              <span>{{ errorMessage }}</span>
            </div>
            <v-btn
              type="submit"
              color="primary"
              block
              size="large"
              :loading="loading"
              class="submit-btn"
            >
              <v-icon left>mdi-lock-reset</v-icon>
              {{ $t("text.reset-password") }}
            </v-btn>
          </v-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { UsersApi } from "../../apis";
export default {
  data() {
    return {
      loading: false,
      email: "",
      emailRules: [
        (v) => !!v || this.$t("text.email-is-required"),
        (v) => /.+@.+\..+/.test(v) || this.$t("text.email-must-be-valid"),
      ],
      errorMessage: "",
    };
  },
  watch: {
    "form.email"(val) {
      if (this.$refs.resetForm) {
        this.$refs.resetForm.validate();
      }
    },
  },
  methods: {
    clearErrorMessage() {
      this.errorMessage = "";
    },
    getToken() {
      const query = this.$route.query;
      return query.token || "";
    },
    async handleForgotPassword() {
      if (!this.$refs.resetForm.validate()) return;
      try {
        this.$util.showLoading();
        const result = await new UsersApi().forgotPassword({
          postForgotPasswordRequest: {
            email: this.email,
          },
        });
        if (result.status === 200) {
          this.$router.push({ name: "forgot-password-success" });
        } else {
          this.errorMessage = this.$t("message.user-not-found");
        }
      } catch (err) {
        this.errorMessage = this.$t("message.user-not-found");
      } finally {
        this.$util.hideLoading();
      }
    },
  },
};
</script>

<style scoped>
.auth-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: url("../../assets/background.png") center center/cover no-repeat;
}

.auth-left-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  height: 350px;
}

.auth-content {
  text-align: center;
  color: white;
  z-index: 2;
  position: relative;
}

.logo-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.auth-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 0 12px;
}

.auth-right-panel {
  display: flex;
  justify-content: center;
}

.auth-form-container {
  width: 100%;
  max-width: 400px;
  background: #fff;
  border-radius: 16px;
  padding: 32px 24px;
}

.auth-form-header {
  text-align: center;
  margin-bottom: 32px;
}

.auth-form-header h2 {
  font-size: 1.75rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
}

.auth-form-header p {
  color: #64748b;
  margin: 0;
}

.form-group label {
  display: block;
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
}

.submit-btn {
  margin-top: 24px;
  border-radius: 12px;
  font-weight: 600;
  text-transform: none;
  height: 48px;
}

.success-message {
  color: #16a34a;
  font-weight: 600;
}

.error-message {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #dc2626;
  border-radius: 8px;
  padding: 10px 0 0 0;
  font-weight: 600;
  font-size: 14px;
}

/* Responsive */
@media (max-width: 768px) {
  .auth-container {
    flex-direction: column;
  }

  .auth-left-panel {
    min-height: 280px;
  }

  .auth-right-panel {
    padding: 20px;
  }

  .auth-logo h1 {
    font-size: 2rem;
  }
}

.auth-container {
  .auth-right-panel {
    height: calc(100vh - 500px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

@media (max-height: 768px) {
  .auth-container {
    .auth-right-panel {
      height: calc(100vh - 280px);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .auth-left-panel {
      height: 280px;
    }
  }
}
</style>